import { Theme } from "@mui/material";
import { GlobalStyles } from "@mui/material";

const GlobalCss = ({ theme }: { theme: Theme }) => {
  const globalStyle = `
 
  
*,
*::before,
*::after {
 margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
    html {
      font-size: 62.5%;
    }

    html,
    body,
    #root {
      height: 100%;
      width: 100%;
    }

    body {
      background-color: #fff;
    }

    a { color: inherit; text-decoration: none;} 

    ul {
      list-style:none;
    }

    ul, li { /* reset the margin and padding */
      margin: 0;
      padding: 0;
   }
`;

  return <GlobalStyles styles={globalStyle} />;
};

export default GlobalCss;
